import React, { Component } from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import { Button, FormControl } from "react-bootstrap"
import { DckSelectors, DckActionCreators } from "dck-redux"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"

import * as ItemTypes from "../../../redux/items/types"
import { browserHistory, Link } from "react-router"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import AlertModal from "../../fragments/AlertModal"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import {
  DEFAULT_NAV_PAGE,
  DEFAULT_NAV_SIZE,
  getDefaultPagedResult,
  scrollToTop,
  sortGLAccounts,
  sortNumber
} from "../../../lib/utils"
import JournalEntryTable from "./JournalEntryTable"
import {
  buildJournalEntryQueryString,
  checkAndRoute,
  getJournalSortKeyFromBootstrapTable,
  handleSortChange
} from "../../../lib/queryStringBuilder"
import TransactionSeachPanel from "./TransactionSeachPanel"
import PropTypes from 'prop-types'

class ListJournalEntries extends Component {

  static contextTypes = {
    router: PropTypes.object
  }

  authenticated = new Authenticated()
  isAdminOrAccountant = this.authenticated.isAdmin() || this.authenticated.isAccountant()

  state = {
    journalEntry: null,
    running: false,
    success: false,
    error: null,
    runningUpdate: false,
    comments: '',
  }

  componentDidMount() {
    this.props.loadGLAccounts()
    this.readQueryString()
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.readQueryString()
    }
  }

  readQueryString = () => {
    const filteringOptions = buildJournalEntryQueryString(this.props.location)
    this.props.loadData(filteringOptions)
  }

  onPageChange = currentPage => {
    checkAndRoute('page', currentPage, currentPage !== DEFAULT_NAV_PAGE, false,
      this.context, this.props.location)
    scrollToTop()
  }

  onSizePerPageList = sizePerPage => {
    checkAndRoute('size', sizePerPage, sizePerPage !== DEFAULT_NAV_SIZE, true,
      this.context, this.props.location)
    scrollToTop()
  }

  onFilterChange = (filterName, filterValue) =>{
    checkAndRoute(filterName, filterValue, !!filterValue, true,
      this.context, this.props.location)
    scrollToTop()
  }

  onSortChange = (sortName, sortOrder) => {

    handleSortChange(
      getJournalSortKeyFromBootstrapTable(sortName),
      sortOrder,
      this.context,
      this.props.location
    )
  }

  doClearFilters = () => {
    this.context.router.push({
      pathname: this.props.location.pathname,
    })
  }

  handleReverseJournal = journalEntry => this.setState({ 
    journalEntry,
    running: false,
    success: false,
    error: null
  })

  confirmReverseJournal = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { journalEntry: { transactionId, transactionDate }, comments } = this.state

    blockingFetchService(
      accessToken => apiServerApi.reverseJournalEntry(accessToken, transactionId, transactionDate, comments),
      _ => {
        this.setState({ success: true })
        this.readQueryString()
        setTimeout(this.closeReverseJournalForm, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  confirmRunningBalance = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.updateRunningBalance(accessToken),
      _ => {
        this.setState({ success: true })
        setTimeout(this.closeRunningBalanceForm, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  shouldDisableDelete = ({ reversed, manualEntry }) => reversed || !manualEntry

  commentsChanged = comments => this.setState({ comments })

  closeReverseJournalForm = () => this.setState({ journalEntry: null })

  renderDeletionConfirmContent = () => {

    const { running, success, error, comments } = this.state
    return (
      <div>
        <label>Comments (Optional)</label>
        <FormControl componentClass="textarea"
          value={ comments } id='comments' placeholder="Enter text"
          onChange={e => this.commentsChanged(e.target.value)}
        />
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderRunningBalanceContent = () => {

    const { running, success, error } = this.state
    return (
      <div>
        <h3>Do you want to execute Update Running Balance?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  closeRunningBalanceForm = () => this.setState({ runningUpdate: false })

  renderRunningBalanceButton = () => (
    <div className='absolute-top-right-button'>
      <Button bsStyle="info" onClick={() => this.setState({ runningUpdate: true })}>
        <FontAwesome name='folder' /> Update Running Balance
      </Button>
    </div>
  )

  detailsLink = id => `/journalentries/${id}/detail`

  renderDetailLink = (id, content) =>
    <Link to={ this.detailsLink(id) } className="p-5">
      { content }
    </Link>

  render() {
    const { journalEntries, glAccounts, location: { query } } = this.props,

    { content, currentPage, pageSize, totalElements } = journalEntries,

    { journalEntry, running, runningUpdate } = this.state

    return (
      <div>
        <CustomBreadCrumb activeText='Journal entries' data={[{ url: '/accounting', title: 'Accounting' }]} />

        <TransactionSeachPanel
          glAccounts={ glAccounts }
          filterChanged={ this.onFilterChange }
          doClearFilters={ this.doClearFilters }
          query={ query }
        />

        <JournalEntryTable
          items={ content }
          addNewLabel="Add Journal Entry"
          addNewHandler={() => browserHistory.push("/journalentries/create")}
          handleDelete={ this.handleReverseJournal }
          deleteLabel='Reverse'
          disableDelete={ this.shouldDisableDelete }
          iconName='rotate-left'
          shouldRenderToolbar={ this.isAdminOrAccountant }

          dataTotalSize={ totalElements }
          page={ Math.floor(Number(currentPage) / Number(pageSize)) + 1 }
          onPageChange={ this.onPageChange }
          sizePerPage={ Number(pageSize) }
          onSizePerPageList={ this.onSizePerPageList }
          onSortChange={ this.onSortChange }
        >
          <TableHeaderColumn
            dataField="id"
            dataSort
            dataAlign='center'
            width="100px"
            dataFormat={(id, { reversed, transactionId }) => this.renderDetailLink(transactionId, 
              <span className={ reversed ? 'red' : '' }>{ id }</span>)
            }>
            Entry ID
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="transactionId"
            dataSort
            dataAlign='center'
            columnClassName="min-w-120"
            dataFormat={(value, { reversed }) => this.renderDetailLink(value, 
              <span className={ reversed ? 'red' : '' }>{ value }</span>)
            }>
            Transaction ID
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="transactionDateFormatted"
            dataSort
            dataAlign='center'
            columnClassName="min-w-120"
          >
            Transaction Date
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="glAccountType"
            dataFormat={ cell => <small>{ cell }</small> }
            dataAlign='center'
            columnClassName="min-w-120"
          >
            Type
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="glAccountName"
            dataSort
            dataAlign='center'
            columnClassName="min-w-120"
          >
            Account
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="debitsFormatted"
            sortFunc={(a, b, order) => sortNumber(a.amount, b.amount, order)}
            dataAlign='center'
            columnClassName="min-w-120"
          >
            Debits
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="creditsFormatted"
            sortFunc={(a, b, order) => sortNumber(a.amount, b.amount, order)}
            dataAlign='center'
            columnClassName="min-w-120"
          >
            Credits
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="createdOnFormatted"
            dataAlign="center"
            dataSort
            columnTitle
            columnClassName='text-xs'
            width="140px"
          >
            Created On
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="reversed"
            dataAlign="center"
            dataSort
            width="100px"
            tdStyle={{ verticalAlign: 'middle' }}
            dataFormat={value => value ? <FontAwesome style={{ color: 'green' }} name='check' /> : ''}
          >
            Reversed
          </TableHeaderColumn>

          <TableHeaderColumn
            isKey
            dataField="id"
            dataAlign="center"
            width="80px"
            dataFormat={(_, { transactionId }) =>
              <span className="flex-detail">
                { this.renderDetailLink(transactionId, <FontAwesome name="eye" title='View' />) }
              </span>
            }
          />
        </JournalEntryTable>

        <AlertModal
          show={ !!journalEntry }
          title={ "Reverse journal entry: " + (journalEntry && journalEntry.transactionId ? journalEntry.transactionId : '') }
          body={ this.renderDeletionConfirmContent() }
          bsStyle="danger"
          close={ this.closeReverseJournalForm }
          confirm={ this.confirmReverseJournal }
          proceedText="Confirm"
          disabled={ running }
        />

        <AlertModal
          show={ runningUpdate }
          title="Update Running Balance"
          body={ this.renderRunningBalanceContent() }
          bsStyle="info"
          close={ this.closeRunningBalanceForm }
          confirm={ this.confirmRunningBalance }
          proceedText="Proceed"
          disabled={ running }
        />
      </div>
    )
  }
}

const mapStateToProps = state => {

  const originalPagedEntries = DckSelectors.selectAllItems(state, ItemTypes.JournalEntry),

  journalEntries = originalPagedEntries instanceof Array 
    ? getDefaultPagedResult()
    : originalPagedEntries,

  glAccounts = DckSelectors.selectAllItems(state, ItemTypes.GLAccount)
  sortGLAccounts(glAccounts)

  return { journalEntries, glAccounts }
},

mapDispatchToProps = dispatch => ({

  loadData: filteringOptions => dispatch(DckActionCreators.itemsLoad(ItemTypes.JournalEntry, filteringOptions)),

  loadGLAccounts: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListJournalEntries)



// WEBPACK FOOTER //
// ./src/components/Accounting/JournalEntries/List.js